import { get } from 'axios'
import formatCase from '@/helpers/format-case'

const URL = '/recommendations'

const formatMetricImage = metric => {
  const id = formatCase('camel-slug', metric._id).toLowerCase()
  metric.image = `https://s3.amazonaws.com/teamculture/metrics-icons/${id}.svg`
}

export const getRecommendations = (metricsId, exclude = '') => {
  const idToExclude = exclude ? `&exclude=${exclude}` : ''
  return get(`${URL}?metrics=${metricsId}${idToExclude}`).then(res => {
    if (res.status === 204) return []

    res.data.recommendations.map(r => r.metrics.map(formatMetricImage))

    return res.data.recommendations
  })
}

export const getRecommendationById = recomendationId =>
  get(`${URL}/${recomendationId}`)
    .then(({ status, data }) => (status === 204 ? { metrics: [] } : data))
    .then(data => {
      data.metrics.map(formatMetricImage)
      return data
    })

export default {
  getRecommendations,
  getRecommendationById,
}
